var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recordSetting"},[(_vm.hasChild === undefined)?_c('main-record-setting',{attrs:{"selected-records":_vm.selectedRecords,"selected-cams":_vm.selectedItems}}):_c('record-download',{attrs:{"selected-items":_vm.selectedItems,"items":_vm.items},on:{"onSelect":_vm.handleDownloadSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }